module.exports = __webpack_public_path__ + "static/media/ic_people_inactive.342e9661.svg";